import { render, staticRenderFns } from "./wechatWebView.vue?vue&type=template&id=4a4638bf&scoped=true&"
import script from "./wechatWebView.vue?vue&type=script&lang=js&"
export * from "./wechatWebView.vue?vue&type=script&lang=js&"
import style0 from "./wechatWebView.vue?vue&type=style&index=0&id=4a4638bf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4638bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/deploy/iot-product-tool/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a4638bf')) {
      api.createRecord('4a4638bf', component.options)
    } else {
      api.reload('4a4638bf', component.options)
    }
    module.hot.accept("./wechatWebView.vue?vue&type=template&id=4a4638bf&scoped=true&", function () {
      api.rerender('4a4638bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/wechatWebView.vue"
export default component.exports